import React from 'react';
import {Button, ModalRequest} from "../common";
import {BUTTON_TYPES} from "../../types";

const WarningModal = (
  {
    open,
    onClose,
    onCloseWarningModal,
    title = 'Вы уверены?',
    subtitle = 'Весь прогресс будет утерян...'
  }: {
    open: boolean;
    onClose?: () => void;
    onCloseWarningModal: () => void;
    title?: string;
    subtitle?: string;
  }) => {
  const onCloseAllModals = () => {
    onClose?.();
    onCloseWarningModal();
  }

  return (
    <ModalRequest open={open} onClose={onCloseWarningModal} title={title}>
      <>
        <p className="text-black text-center text-xl font-bold">{subtitle}</p>

        <div className="flex items-center justify-center w-full gap-5 mt-5">
          <Button title={'Отмена'} onClick={onCloseWarningModal} type={BUTTON_TYPES.SUCCESS} />
          <Button title={'Да'} onClick={onCloseAllModals} type={BUTTON_TYPES.ERROR} />
        </div>
      </>
    </ModalRequest>
  )
};

export default WarningModal;
